import { render, staticRenderFns } from "./performanceResult.vue?vue&type=template&id=5913e2bb&scoped=true&"
import script from "./performanceResult.vue?vue&type=script&lang=js&"
export * from "./performanceResult.vue?vue&type=script&lang=js&"
import style0 from "./performanceResult.vue?vue&type=style&index=0&id=5913e2bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913e2bb",
  null
  
)

export default component.exports